import {debounce as _debounce, isEmpty as _isEmpty} from 'lodash';
import {gql} from '@apollo/client';

import {convertToInt} from '@utils/helpers';

export const clientFormData = {
    client: {
        crm_id: null,
        id: '',
        name: '',
        brands: '',
        address: '',
        vat_number: '',
        notes: '',
        notification_email_recipients: [],
        is_lbc_stream_playback_enabled: false,
        country: {id: ''},
        client_types: [],
        bookmaker: {id: ''},
        is_disabled: null,
        is_internal: null,
        is_strategic: null,
        creation_datetime: '',
        creation_user: {
            id: '',
            name: '',
        },
        update_datetime: '',
        update_user: {
            id: '',
            name: '',
        },
    },
    bookmakers: [],
    countries: [],
    clientTypes: [],
};

export function getClientTypesData(clientTypes, prevClientTypes, options = false) {
    if (clientTypes && clientTypes !== prevClientTypes) {
        return clientTypes.map((clientType) => {
            if (options) {
                return {
                    value: convertToInt(clientType.value),
                    key: clientType.text,
                };
            } else {
                return convertToInt(clientType.id);
            }
        });
    }

    return [];
}

export function getBookmakerOption(bookmakerOption, bookmaker) {
    if (bookmakerOption?.length) {
        return bookmakerOption;
    } else if (bookmaker) {
        return [
            {
                key: parseInt(bookmaker.id),
                text: `${bookmaker.name} (${bookmaker.id})`,
                value: bookmaker.id,
            },
        ];
    }

    return [];
}

export function getLBCPlaybackEnabled(isLbcStreamPlaybackEnabled, previsLbcStreamPlaybackEnabled) {
    return !!(isLbcStreamPlaybackEnabled && isLbcStreamPlaybackEnabled !== previsLbcStreamPlaybackEnabled);
}

export function getNotificationRecipients(notificationEmailRecipients, prevNotificationEmailRecipients) {
    if (
        notificationEmailRecipients &&
        !_isEmpty(notificationEmailRecipients) &&
        notificationEmailRecipients !== prevNotificationEmailRecipients
    ) {
        return notificationEmailRecipients;
    }

    return [];
}

export const searchBookmaker = _debounce((
    e,
    target,
    client,
    query,
    setState
) => {
    const searchString = target.searchQuery || '';

    if (3 <= searchString.length || !isNaN(searchString)) {
        setState({loadingBookmakers: true});
        client
            .query({
                fetchPolicy: 'network-and-cache',
                query: gql`${query}`,
                variables: {search: searchString},
            })
            .then((data) => {
                const bookmakerOption = data.data.bookmakers.map((bookmaker) => ({
                    key: convertToInt(bookmaker.value),
                    text: `${bookmaker.text} (${bookmaker.value})`,
                    value: bookmaker.value,
                }));
                setState({loadingBookmakers: false, bookmakerOption});
            })
            .catch(() => {
                setState({loadingBookmakers: false, bookmakerOption: []});
            });
    }
}, 1300);

export const toggleOption = (checked, inputName, setState) => {
    setState(() => ({
        [inputName]: checked,
    }));
};

export const onChangeNotificationEmailRecipients = (data, setState) => {
    if (undefined !== data) {
        setState(() => ({
            notificationEmailRecipients: data,
        }));
    }
};
